import { Link } from 'react-router-dom';
import { Container, Box, Typography, Button } from '@mui/material';
import Divider from '@mui/material/Divider';
import useStore from '../stores';

function Footer() {
  const version = APP_VERSION;

  const userProfile = useStore((state) => state.userProfile);
  const { verified = false } = userProfile || {};

  if (!verified) return null;

  return (
    <Container
      style={{
        // position: 'absolute',
        bottom: 0,
        marginTop: 50,
        marginBottom: 50,
        width: '100%',
        height: '2.5rem',
      }}
    >
      <Divider style={{ marginBottom: 10 }} />
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Button
          component={Link}
          to="/"
          color="secondary"
          variant="text"
          size="small"
          aria-label="Home"
        >
          Home
        </Button>
        <span className="ms-2 me-2">|</span>
        <Button
          component={Link}
          to="https://www.mcgovern.org/"
          target="_blank"
          color="secondary"
          variant="text"
          size="small"
          aria-label="Visit PJMF website"
        >
          PJMF
        </Button>
        <span className="ms-2 me-2">|</span>
        <Button
          component={Link}
          to="https://fdd-public.s3.amazonaws.com/tou_v1.0.pdf"
          color="secondary"
          target="_blank"
          variant="text"
          size="small"
          aria-label="Terms of Use (PDF)"
        >
          Terms of Use (PDF)
        </Button>
        <span className="ms-2 me-2">|</span>
        <Button
          component={Link}
          to="https://app.getguru.com/card/TjREnMrc/The-Patrick-J-McGovern-Foundation-Privacy-Policy-"
          color="secondary"
          target="_blank"
          aria-label="Privacy Policy"
        >
          Privacy Policy
        </Button>
        <span className="ms-2 me-2">|</span>
        <Button
          component={Link}
          to="/help"
          color="secondary"
          variant="text"
          size="small"
          aria-label="Help Center"
        >
          Help center
        </Button>
      </Box>

      <Typography align="center" variant="body2">
        Version {version}
      </Typography>
    </Container>
  );
}

export default Footer;
